/** Snap a percentage coordinate to the nearest grid step. */
export function snapPct(value: number, gridPct: number, enabled: boolean): number {
  if (!enabled || gridPct <= 0) return value;
  const snapped = Math.round(value / gridPct) * gridPct;
  return Math.min(100, Math.max(0, snapped));
}

export function snapElementBounds(
  patch: { x?: number; y?: number; w?: number; h?: number },
  gridPct: number,
  enabled: boolean,
): { x?: number; y?: number; w?: number; h?: number } {
  if (!enabled) return patch;
  const out = { ...patch };
  if (out.x != null) out.x = snapPct(out.x, gridPct, true);
  if (out.y != null) out.y = snapPct(out.y, gridPct, true);
  if (out.w != null) out.w = Math.max(gridPct, snapPct(out.w, gridPct, true));
  if (out.h != null) out.h = Math.max(gridPct, snapPct(out.h, gridPct, true));
  return out;
}
